<template>
    <div class="container">
        <div class="paramForm">
            <el-form :model="params" label-width="90px" class="approveForm">
                <el-row>
                    <el-form-item label="分类">
                        <el-input v-model="params.type" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="编码">
                        <el-input v-model="params.code" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="名称">
                        <el-input v-model="params.name" clearable></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <div class="paramFormButton">
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
        </div>
        <div class="tableTool">
            <el-button type="primary" icon="el-icon-plus" @click="openCreate">新增</el-button>
            <el-button type="primary" icon="el-icon-delete" @click="deleteConfig">删除</el-button>
        </div>
        <el-table border ref="tableRef" :data="tableData" highlight-current-row class="table-show-current" @row-dblclick="openEditDialog"  @current-change="changeCurrentRow">
            <el-table-column prop="id" align="center" label="ID" width="80"></el-table-column>
            <el-table-column prop="type" align="center" label="分类"></el-table-column>
            <el-table-column prop="code" align="center" label="编码"></el-table-column>
            <el-table-column prop="name" align="center" label="名称"></el-table-column>
            <el-table-column label="排序" width="200" align="center">
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-top" @click="moveUp(scope.$index, scope.row)">上移</el-button>
                    {{scope.row.sort}}
                    <el-button type="text" icon="el-icon-bottom" @click="moveDown(scope.$index, scope.row)">下移</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="comments" align="center" label="说明" show-overflow-tooltip></el-table-column>
            <el-table-column label="更新时间" align="center" width="150">
                <template slot-scope="scope">
                    {{formatTimestamp(scope.row.updatedAt)}}
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                :current-page="pageInfo.pageNum"
                :page-size="pageInfo.pageSize"
                :page-sizes="[10,20, 50, 100, 200]"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
        <!-- 编辑弹出框 -->
        <el-dialog title="编辑" :visible.sync="editDialogVisible" class="abow_dialog" @close='closeEditDialog'>
            <el-form  ref="formRef" label-width="120px" class="approveForm">
                <el-row>
                    <el-form-item label="分类">
                        <el-input v-model="form.type" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="编码">
                        <el-input v-model="form.code"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="名称">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input-number :min="1" v-model="form.sort"></el-input-number>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="说明">
                        <el-input type="textarea" v-model="form.comments"></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <div style="display: flex;justify-content: center;margin-top:10px;">
                    <el-button type="primary" @click="onSubmit">提交</el-button>
                    <el-button @click="closeEditDialog">取消</el-button>
                </div>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { sysDictApi } from '@/api/api-sys';
export default {
    data() {
        return {
            params:{},
            pageInfo:{
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            total: 0,
            editDialogVisible:false,
            form:{},
            currentRow:null,
        };
    },
    created() {
        this.handleSearch();
    },
    methods: {
        getParentList(){
            sysDictApi.findList({type:"EMPTY"}).then(res => {
                if(res != null){
                    res.unshift({code:"EMPTY",name:"上级分类"});
                    this.parentList = res;
                }
            });
        },
        refreshData(){
            sysDictApi.findPageList(this.params,this.pageInfo).then(res => {
                this.tableData = res.records;
                this.total = res.total || 0;
            })
        },
        handleSearch() {
            this.pageInfo.pageNum = 1;
            this.refreshData();
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize= val;
            this.refreshData();
        },
        handleCurrentChange(val){
            this.pageInfo.pageNum= val;
            this.refreshData();
        },
        openCreate() {
            this.form={};
            this.editDialogVisible = true;
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            }
        },
        openEditDialog(data) {
            this.form = JSON.parse(JSON.stringify(data));
            this.editDialogVisible = true;
        },
        changeCurrentRow(val) {
            this.currentRow = val;
        },
        deleteConfig() {
            if (this.currentRow == null) {
                this.$message.error('请选择数据');
                return;
            }
            this.$confirm('确定删除配置', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                sysDictApi.delete(this.currentRow).then(res => {
                    if (res.result) {
                        this.$message.success('删除成功');
                        this.handleSearch();
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            });
        },
        closeEditDialog(){
            this.editDialogVisible = false;
            this.form = {};
        },
        onSubmit(){
            if(this.form.dataType == "BigDecimal" && this.form.dataValue != "" && this.form.dataValue !=null && !isNaN(this.form.dataValue)){
                this.$message.success("数据类型与配置数据格式不匹配");
                return;
            }
            sysDictApi.update(this.form).then(res=>{
                if(res.result){
                    this.$message.success("保存成功");
                    this.closeEditDialog();
                    this.handleSearch();
                }else{
                    this.$message.error(res.msg);
                }
            })
        },
        moveUp(index, row){
            let data = JSON.parse(JSON.stringify(row));
            if(data.sort == null || data.sort == ""){
                data.sort = 1;
            }else{
                data.sort = data.sort-1;
            }
            sysDictApi.update(data).then(res => {
                this.handleSearch();
            });
        },
        moveDown(index, row){
            let data = JSON.parse(JSON.stringify(row));
            if(data.sort == null || data.sort == ""){
                data.sort = 1;
            }else{
                data.sort = data.sort+1;
            }
            sysDictApi.update(data).then(res => {
                this.handleSearch();
            });
        },
    }
}
</script>
